import { motion } from "framer-motion";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";


import burrowLogo from './../assets/images/Events/burrow.jpeg'
import burrowText from './../assets/images/Burrow/burrowText.jpg'
import burrowLaunchImg from './../assets/images/Events/burrowLaunch.jpg'
import burrow1Img from './../assets/images/Events/burrowMenu.jpeg'
import burrow2Img from './../assets/images/Events/burrowMenu2.jpeg'
import burrowBankImg from './../assets/images/Events/burrowBank.jpeg'
import burrowMayBankImg from './../assets/images/Events/burrow4.jpg'
import burrowAmericaImg from './../assets/images/Events/burrowMenuAmerica.jpeg'
import burrowHalloweenImg from './../assets/images/Events/halloween.jpeg'
import burrow1 from './../assets/images/Burrow/slider1.JPEG'
import burrow2 from './../assets/images/Burrow/slider2.JPEG'
import burrow3 from './../assets/images/Burrow/slider3.JPEG'
import burrow4 from './../assets/images/Burrow/slider4.JPEG'
import burrow5 from './../assets/images/Burrow/slider5.JPEG'
import burrow6 from './../assets/images/Burrow/slider6.JPEG'
import burrow7 from './../assets/images/Burrow/slider7.JPEG'
import burrow8 from './../assets/images/Burrow/slider8.JPEG'
import burrow9 from './../assets/images/Burrow/slider9.JPEG'
import burrow10 from './../assets/images/Burrow/slider10.JPEG'
import burrowDj from './../assets/videos/burrowDj.MP4'
import burrowLaunch from './../assets/pdf/burrowLaunch.pdf'
import burrowMenu1 from './../assets/pdf/burrowMenu.pdf'
import burrowMenu2 from './../assets/pdf/burrowMenu2.pdf'
import burrowBank from './../assets/pdf/burrowBank.pdf'
import burrowMayBank from './../assets/pdf/burrowBankMenu2.pdf'
import burrowMayBank2 from './../assets/pdf/burrowMenuAmerica.pdf'

const images = [
  burrow1,
  burrow2,
  burrow3,
  burrow4,
  burrow5,
  burrow6,
  burrow7,
  burrow8,
  burrow9,
  burrow10
]

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut"
    }
  }
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};

const Card = ({ children, className = "" }) => (
  <div className={`rounded-2xl ${className}`}>{children}</div>
);

const CardContent = ({ children, className = "" }) => (
  <div className={className}>{children}</div>
);

export default function BurrowPage() {

  const upcomingEvent = {
    title: "BURROW",
    date: "Saturday 31st October - 7PM - LATE",
    description: "Burrow Social Club is Bringing you its 1st Halloween Party!",
    image: burrowHalloweenImg,
    link: "https://www.skiddle.com/whats-on/Stourbridge/The-Fox-Inn-Stourton/The-Fox-Inn-Presents--Burrow-Halloween-Bash/42838033/"
  };

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const formatPhone = (value) => {
    let cleaned = value.replace(/\s+/g, "");

    if (cleaned.startsWith("0")) {
      return "+44" + cleaned.substring(1);
    }

    if (cleaned.startsWith("44") && !cleaned.startsWith("+44")) {
      return "+" + cleaned;
    }

    return cleaned;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const mailchimpUrl = "https://foxinn-stourton.us18.list-manage.com/subscribe/post?u=3a377c3f23a9a856453ae4700&amp;id=4a064b06c9&amp;f_id=0047b3e6f0";

    const formData = new FormData();

    formData.append("EMAIL", email);
    formData.append("b_3a377c3f23a9a856453ae4700_4a064b06c9", "");

    if (phone) {
      const formatted = formatPhone(phone);
      const isValidPhone = /^\+44\d{9,10}$/.test(formatted);

      if (!isValidPhone) {
        setMessage("Please enter a valid UK phone number (+44...)");
        return;
      }

      formData.append("SMSPHONE", formatted);

      formData.append("mc-SMSPHONE-ack", "true");
    }

    try {
      await fetch(mailchimpUrl, {
        method: "POST",
        body: formData,
        mode: "no-cors",
      });

      setMessage("Thank you! We'll keep you updated.");
      setEmail("");
      setPhone("");
    } catch (error) {
      setMessage("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="bg-[#f5f3ef] text-[#274a59]">
      {/* HERO + ABOUT UPGRADE */}
      <section className="relative w-full overflow-hidden bg-[#f5f3ef]">
        {/* HERO with repositioned background shapes */}
        <section className="relative w-full overflow-hidden bg-[#f5f3ef] h-[100vh] flex items-center justify-center text-center px-6">
          {/* Animated Background Shapes - moved higher */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <motion.div
              animate={{ x: [-50, 50, -50], y: [-20, 20, -20] }}
              transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
              className="absolute w-[500px] h-[500px] bg-[#274a59]/10 rounded-full top-1/4 left-1/3 filter blur-3xl"
            />
            <motion.div
              animate={{ x: [30, -30, 30], y: [20, -20, 20] }}
              transition={{ repeat: Infinity, duration: 25, ease: "linear" }}
              className="absolute w-[400px] h-[400px] bg-[#274a59]/20 rounded-full top-1/3 right-1/4 filter blur-2xl"
            />
            <motion.div
              animate={{ x: [-20, 20, -20], y: [-10, 10, -10] }}
              transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
              className="absolute w-[300px] h-[300px] bg-[#274a59]/15 rounded-full top-1/6 left-1/2 filter blur-2xl"
            />
          </div>

          {/* Hero Text */}
          <motion.div
            className="relative z-10 max-w-4xl text-center"
            initial="hidden"
            whileInView="visible"      // <-- animate every time it enters view
            viewport={{ once: false, amount: 0.3 }} // 'once: false' ensures repeat
            variants={{
              hidden: {},
              visible: { transition: { staggerChildren: 0.15 } }
            }}
          >
            <motion.h1
              className="text-6xl md:text-8xl font-serif tracking-wide mb-6"
              variants={{
                hidden: { opacity: 0, y: 50, scale: 0.95 },
                visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.8, ease: "easeOut" } }
              }}
            >
              BURROW
            </motion.h1>

            <motion.p
              className="uppercase tracking-[0.4em] text-sm mb-6"
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 0.8, y: 0, transition: { duration: 0.8 } }
              }}
            >
              A Fox Social Club
            </motion.p>

            <motion.p
              className="max-w-xl mx-auto text-lg"
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 0.8, y: 0, transition: { duration: 0.8, delay: 0.2 } }
              }}
            >
              Street food, DJs, and a laid-back social experience. A rotating concept bringing together music, food, and atmosphere.
            </motion.p>
          </motion.div>

          {/* burrowText overlay at the bottom */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.06 }}
            transition={{ duration: 2 }}
            className="absolute bottom-0 left-0 w-full flex justify-center pointer-events-none select-none"
          >
            <img
              src={burrowText}
              alt=""
              className="w-[900px] max-w-[90vw] object-contain"
            />
          </motion.div>
        </section>

        {/* ABOUT */}
        <section className="relative py-32 px-6 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="md:w-1/2"
          >
            <h2 className="text-4xl font-serif mb-6">The Social Club</h2>
            <p className="leading-relaxed opacity-80 mb-4">
              BURROW is a recurring social club experience combining curated DJ lineups, premium street food, and a relaxed evening atmosphere.
            </p>
            <p className="leading-relaxed opacity-80">
              Each event brings a new menu, new music, and a new vibe. Designed to feel exclusive but welcoming — a space to eat, drink, and stay late.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="md:w-1/2"
          >
            <Card className="bg-white/60 backdrop-blur border-none shadow-xl overflow-hidden">
              <CardContent className="p-2">
                <motion.img
                  src={burrowLogo}
                  alt="Burrow Social Club"
                  className="rounded-2xl w-full object-cover"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.5 }}
                />
              </CardContent>
            </Card>
          </motion.div>
        </section>
      </section>

      {/* UPCOMING EVENT */}
      <section className="relative py-32 px-6 overflow-hidden">
        {/* background orbs */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <motion.div
            animate={{ x: [-40, 40, -40], y: [-20, 20, -20] }}
            transition={{ repeat: Infinity, duration: 22, ease: "linear" }}
            className="absolute w-[420px] h-[420px] bg-[#274a59]/10 rounded-full top-1/3 left-1/4 blur-3xl"
          />
          <motion.div
            animate={{ x: [30, -30, 30], y: [20, -20, 20] }}
            transition={{ repeat: Infinity, duration: 28, ease: "linear" }}
            className="absolute w-[320px] h-[320px] bg-[#274a59]/20 rounded-full bottom-1/4 right-1/4 blur-2xl"
          />
        </div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.25 }}
          variants={stagger}
          className="relative max-w-6xl mx-auto"
        >
          <motion.h2
            variants={fadeUp}
            className="text-4xl font-serif mb-12 text-center"
          >
            Upcoming Event
          </motion.h2>

          {/* IF EVENT EXISTS */}
          {upcomingEvent?.image || upcomingEvent?.date ? (
            <motion.div
              variants={fadeUp}
              className="grid md:grid-cols-2 gap-12 items-center"
            >
              {/* image */}
              <Card className="bg-white/60 backdrop-blur shadow-xl overflow-hidden">
                <CardContent className="p-2">
                  <motion.img
                    src={upcomingEvent.image}
                    alt={upcomingEvent.title}
                    className="rounded-2xl w-full object-cover"
                    whileHover={{ scale: 1.04 }}
                    transition={{ duration: 0.5 }}
                  />
                </CardContent>
              </Card>

              {/* content */}
              <div>
                <h3 className="text-3xl md:text-4xl font-serif mb-4">
                  {upcomingEvent.title}
                </h3>

                {upcomingEvent.date && (
                  <p className="uppercase tracking-[0.3em] text-sm opacity-70 mb-4">
                    {upcomingEvent.date}
                  </p>
                )}

                <p className="opacity-80 leading-relaxed mb-8">
                  {upcomingEvent.description}
                </p>

                {upcomingEvent.link && (
                  <motion.a
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.98 }}
                    href={upcomingEvent.link}
                    className="inline-block bg-[#274a59] text-white px-8 py-3 rounded-full shadow-lg"
                  >
                    View Event
                  </motion.a>
                )}
              </div>
            </motion.div>
          ) : (
            /* NO EVENT - SIMPLE COMING SOON */
            <motion.div
              variants={fadeUp}
              className="text-center py-20"
            >
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ repeat: Infinity, duration: 4 }}
                className="text-6xl font-serif mb-6"
              >
                BURROW
              </motion.div>

              <p className="uppercase text-lg opacity-60 mb-6">
                Next Event
              </p>

              <motion.p
                animate={{ opacity: [0.4, 1, 0.4] }}
                transition={{ repeat: Infinity, duration: 2.5 }}
                className="text-xl opacity-80"
              >
                Coming Soon
              </motion.p>
            </motion.div>
          )}
        </motion.div>
      </section>

      {/* MEDIA EXPERIENCE SECTION */}
      <section className="relative w-full overflow-hidden bg-white/10">
        {/* Video Hero */}
        <div className="relative w-full h-[80vh] overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute w-full h-full object-cover"
            src={burrowDj}
          />
          {/* Gradient overlay */}
          <div className="absolute w-full h-full bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
          {/* Centered text overlay */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="absolute inset-0 flex flex-col items-center justify-center text-center px-6"
          >
            <h2 className="text-5xl md:text-6xl font-serif text-white mb-4 drop-shadow-lg">
              Experience BURROW
            </h2>
            <p className="text-lg md:text-xl text-white/80 max-w-xl drop-shadow-md">
              Street food, DJs, and a laid-back social experience. Immerse yourself in a rotating concept of music, food, and vibes.
            </p>
          </motion.div>
        </div>

        {/* Continuous Gallery */}
        <div className="py-24 px-6">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            variants={stagger}
          >
            <motion.h2
              variants={fadeUp}
              className="text-4xl font-serif mb-12 text-center"
            >
              Gallery
            </motion.h2>

            <Swiper
              modules={[Autoplay]}
              spaceBetween={12}
              slidesPerView={5}
              loop={true}
              speed={5000}
              autoplay={{ delay: 0, disableOnInteraction: false }}
              freeMode={true}
              freeModeMomentum={false}
              breakpoints={{
                320: { slidesPerView: 2 },
                480: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView: 5 },
                1280: { slidesPerView: 6 },
              }}
            >
              {images.map((img, idx) => (
                <SwiperSlide key={idx}>
                  <Card className="overflow-hidden rounded-2xl shadow-md bg-white relative group">
                    <div className="aspect-[4/5] bg-gray-200 flex items-center justify-center overflow-hidden">
                      <motion.img
                        src={img}
                        alt={`Burrow Image ${idx + 1}`}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-20 transition-opacity rounded-2xl"></div>
                    </div>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </motion.div>
        </div>

        {/* Cinematic Menus */}
        <div className="py-16 px-6 bg-white/20">
          <div className="max-w-7xl mx-auto">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.2 }}
              variants={stagger}
            >
              <motion.h2
                variants={fadeUp}
                className="text-4xl font-serif mb-12 text-center"
              >
                Previous Menus
              </motion.h2>

              <motion.div
                variants={stagger}
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
              >
                {[
                  { title: "Launch Menu", file: burrowLaunch, thumbnail: burrowLaunchImg },
                  { title: "February Social Club", file: burrowMenu1, thumbnail: burrow1Img },
                  { title: "March Social Club", file: burrowMenu2, thumbnail: burrow2Img },
                  { title: "Bank Holiday Brunch", file: burrowBank, thumbnail: burrowBankImg },
                  { title: "May Bank Holiday", file: burrowMayBank, thumbnail: burrowMayBankImg },
                  { title: "May Bank Holiday No. 2", file: burrowMayBank2, thumbnail: burrowAmericaImg },
                ].map((menu, idx) => (
                  <motion.div key={idx} variants={fadeUp}>
                    <a href={menu.file} target="_blank" rel="noopener noreferrer">
                      <Card className="relative overflow-hidden rounded-3xl shadow-xl group hover:shadow-2xl transition-shadow duration-500 cursor-pointer">
                        {/* Thumbnail Preview */}
                        <div className="aspect-[4/5] w-full overflow-hidden">
                          <motion.img
                            src={menu.thumbnail}
                            alt={`${menu.title} Thumbnail`}
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                          />
                          {/* Soft overlay */}
                          <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-30 transition-opacity rounded-3xl"></div>
                        </div>

                        {/* Title and Icon */}
                        <CardContent className="p-6 text-center bg-white/70 backdrop-blur-md -mt-16 relative z-10 rounded-t-2xl">
                          <h3 className="font-serif text-xl">{menu.title}</h3>
                        </CardContent>
                      </Card>
                    </a>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-40 px-6 bg-gradient-to-b from-[#274a59] to-[#1f3a44] text-white flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 1 }}
          className="text-center max-w-2xl w-full"
        >
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0 }}
            className="text-4xl md:text-5xl font-serif mb-6"
          >
            Stay in the Loop
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 0.9, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mb-10 text-lg md:text-xl opacity-90"
          >
            Sign up to receive announcements for upcoming BURROW events, exclusive menus, and special experiences.
          </motion.p>

          <motion.form
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full max-w-xl mx-auto"
          >
            <input
              type="email"
              placeholder="Enter your email..."
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full sm:flex-1 p-4 rounded-full text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white"
            />

            <input
              type="tel"
              placeholder="Phone (optional, +44...)"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full sm:flex-1 p-4 rounded-full text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white"
            />
            <button
              type="submit"
              className="bg-white text-[#274a59] font-bold px-8 py-3 rounded-full hover:opacity-90 transition text-lg"
            >
              Notify Me
            </button>
          </motion.form>

          {message && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="mt-6 text-sm md:text-base text-green-400"
            >
              {message}
            </motion.p>
          )}
        </motion.div>

        {/* Optional subtle decorative background */}
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
          className="absolute top-0 left-1/2 w-48 h-48 bg-white/10 rounded-full filter blur-3xl pointer-events-none"
        />
      </section>
    </div>
  );
}
